import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EmailPreference, IEmailPreference } from '../models/emailPreference';
import { EmailPreferenceWrite } from '../models/emailPreferenceWrite';
import { ApiVersions } from './api-version';
import { BaseService } from './base.service';

@Injectable({ providedIn: 'root' })
export class EmailPreferencesService extends BaseService {
  getCommercialEmailPreference(personId: string): Observable<EmailPreference> {
    // For now we assume there's only one type of email to unsubscribe from.
    // If that changes, this will need to be redesigned.
    return this.get<IEmailPreference[]>(this.getPath(personId), null, ApiVersions.v1_0).pipe(
      map((results) => new EmailPreference(results.filter((r) => !r.isReadOnly)[0]))
    );
  }

  updateEmailPreference(
    personId: string,
    emailType: string,
    model: EmailPreferenceWrite
  ): Observable<any> {
    const path = `${this.getPath(personId)}/${emailType}`;
    return this.put(path, JSON.stringify(model), null, ApiVersions.v1_0);
  }

  private getPath(personId: string): string {
    return `members/${personId}/email-preferences`;
  }
}
